import * as React from 'react';
import { SVGProps } from 'react';

const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#filter_svg__a)'>
      <g clipPath='url(#filter_svg__b)'>
        <path
          d='M13.5 21h-3A1.5 1.5 0 0 1 9 19.5v-5.693L3.442 8.25A1.5 1.5 0 0 1 3 7.192V4.5A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5v2.692a1.5 1.5 0 0 1-.442 1.058L15 13.807V19.5a1.5 1.5 0 0 1-1.5 1.5Zm-9-16.5v2.692l6 6V19.5h3v-6.307l6-6V4.5h-15Z'
          fill='#000'
        />
      </g>
    </g>
    <defs>
      <clipPath id='filter_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
      <clipPath id='filter_svg__b'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFilter;
